import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { withPermissions, permissions } from '../../shared/authorization';
import columnDefinitions from '../../shared/columnDefinitions/accountsMapPage';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';
import config from '../../config';

import {
  sharedActions,
} from './store/actions';
import AccountMapAdminColumnRenderer from './AccountMapAdminColumnRenderer.component';
import AddEditModal from './addEditModal.component';
import DeleteModal from './deleteAccountMapModal.component';
import AdminImportPage from '../shared/adminImportPage.component';
import downloadXlsx from './downloadXlsx';

const AccountMapPage = ({
  canModifyInSelectedPeriod,
}) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Balance_Sheet_Management_Account_Map_${periodName}`,
    []);

  const idFieldComparator = useCallback((accountMap, importedAccountMap) => (
    accountMap.bsmAccount === importedAccountMap.bsmAccount
    && accountMap.glAccount === importedAccountMap.glAccount
  ), []);

  const hideAttributes = true;

  return (
    <AdminImportPage
      pageName={adminPageNames.ACCOUNT_MAP}
      singularTitle
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddEditModal}
      RemoveEntityModal={DeleteModal}
      adminColumnRenderer={AccountMapAdminColumnRenderer}
      addEntityMessage="Add Account Map"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      exportToExcel={downloadXlsx}
      generateTemplateFileName={generateTemplateFileName}
      templatePath={config.templates.ACCOUNT_MAP}
      comparatorConfig={{
        idField: 'periodName',
        idFieldComparator,
      }}
      pageTitle={adminPageTitles.ACCOUNT_MAP}
      hideImporting={hideAttributes}
      hideAdd={hideAttributes}
    />
  );
};

AccountMapPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.ACCOUNT_MAP_PAGE)(AccountMapPage);
